import { useState, useEffect } from "react";
import './RandomCounter.scss';
const RandomCounter = () => {
    const [randomChange, setRandomChange] = useState(false);
    const [randomCounter, setRandomCounter] = useState();
    useEffect(() => {
		fetch('https://www.random.org/integers/?num=1&min=-50&max=50&col=1&base=10&format=plain&rnd=new')
			.then(res => res.json())
			.then(res => setRandomCounter(res))
      .catch(err => console.log(err))
    }, [randomChange]);
    return (
        <div className='randomCounter'>
                <h2>Counter + API random.org</h2>
                <div className="randomCounter__container">
                <div className="randomCounter__block"> {randomCounter } </div>
                <div className="randomCounter__controls">
                <button onClick={() => setRandomChange( randomChange => !randomChange )} >RND</button>
                <button onClick={ () => setRandomCounter(0)} >RESET</button>
                </div>
            </div>
        </div>
    );
};

export default RandomCounter;